// termsOfService.js
// Basic Terms of Service for a small pilot application.
// Update placeholders before publishing.

export const TERMS_OF_SERVICE = {
  title: "Terms of Service",
  lastUpdated: "January 28, 2026", // update as needed
  sections: [
    {
      heading: "Acceptance of Terms",
      body: [
        "By accessing or using this application (the “Service”), you agree to be bound by these Terms of Service.",
        "If you do not agree to these terms, you may not use the Service."
      ]
    },
    {
      heading: "Description of the Service",
      body: [
        "The Service provides a platform for businesses to create profiles, list menu items, and share location information, and for users to view that information.",
        "The Service is provided as-is for a small pilot and may change or be discontinued at any time."
      ]
    },
    {
      heading: "User Accounts",
      body: [
        "You are responsible for maintaining the confidentiality of your account credentials.",
        "You agree to provide accurate and complete information when creating and maintaining your account.",
        "You are responsible for all activity that occurs under your account."
      ]
    },
    {
      heading: "User Content",
      body: [
        "You retain ownership of the content you submit, including business information and menu items.",
        "By submitting content, you grant us a non-exclusive right to display and use that content as necessary to operate the Service.",
        "You agree not to submit content that is unlawful, misleading, or harmful."
      ]
    },
    {
      heading: "Acceptable Use",
      body: [
        "You agree not to misuse the Service or attempt to access it in an unauthorized way.",
        "You may not interfere with the operation or security of the Service.",
        "We reserve the right to suspend or terminate accounts that violate these terms."
      ]
    },
    {
      heading: "Third-Party Services",
      body: [
        "The Service may rely on third-party services (such as hosting or authentication providers).",
        "We are not responsible for outages or issues caused by third-party services."
      ]
    },
    {
      heading: "Disclaimer of Warranties",
      body: [
        "The Service is provided “as is” and “as available,” without warranties of any kind.",
        "We do not guarantee that the Service will be uninterrupted, error-free, or fully accurate."
      ]
    },
    {
      heading: "Limitation of Liability",
      body: [
        "To the fullest extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.",
        "Your use of the Service is at your own risk."
      ]
    },
    {
      heading: "Termination",
      body: [
        "We may suspend or terminate your access to the Service at any time, with or without notice, if you violate these terms or if we discontinue the Service.",
        "You may stop using the Service at any time."
      ]
    },
    {
      heading: "Changes to These Terms",
      body: [
        "We may update these Terms of Service from time to time.",
        "If changes are made, the “Last Updated” date above will be revised.",
        "Continued use of the Service constitutes acceptance of the updated terms."
      ]
    },
    {
      heading: "Contact Information",
      body: [
        "If you have questions about these Terms of Service, contact us at:",
        "• Email: [YOUR SUPPORT EMAIL]"
      ]
    }
  ]
};
